import type { FragmentOf } from '@/utilities/gql';
import { gql } from '@/utilities/gql';

export const FISCAL_DATA_FRAGMENT = gql(`
  fragment FiscalDataFields on Valuation @_unmask {
    fiscalData {
      mostRecentReportedDate
      yearlyTimeSeries {
        year
        data {
          netIncome
          revenue
          endDate
          totalSharesOutstanding
        }
      }
    }
  }
`);

export type FiscalData = FragmentOf<typeof FISCAL_DATA_FRAGMENT>;
